import { css } from 'styled-components';
import theme from 'theme/theme';

const { values: breakpoints } = theme.breakpoints;

export const media = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => css`
    @media (min-width: ${breakpoints[label]}px) {
      ${css(...args)};
    }
  `;
  return accumulator;
}, {});
